/**
 * OVERRIDE Navigation.jsx
 * REASON: Custom Navigation with overflow handling.
 * Items that don't fit in the available space are grouped into a "Mais" dropdown.
 */

import Navigation from '../../../../../components/theme/Navigation/Navigation';

export default Navigation;
